module.exports = __webpack_public_path__ + "static/media/report.d900b8a4.svg";